import { render } from "./IconItemCategoryFurniture.vue?vue&type=template&id=1d08aef1"
import script from "./IconItemCategoryFurniture.vue?vue&type=script&lang=js"
export * from "./IconItemCategoryFurniture.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__